/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable no-underscore-dangle */
import { config } from './confing';
import { ThemeService } from './services/theme.service';
import { eventModel } from './services/message.service';
import { MessageService } from 'src/app/services/message.service';
/* eslint-disable @typescript-eslint/naming-convention */
import { getPrenotazioni, getQuantita } from './models/ordine.models';
import { clienteBE } from 'src/app/models/sync.model';
import { CartService } from './services/cart.service';
import { NetworkService } from './services/network.service';
import { User } from './models/user.model';
import { UserService } from './services/user.service';
import { Component, OnInit } from '@angular/core';
import { ConnectionStatus } from '@capacitor/network';
import { Platform } from '@ionic/angular';
import { cart, ordineDaTrasmettere } from './models/cart.model';
import { Observable, Subject } from 'rxjs';
import * as _ from 'lodash';
import { db } from 'src/app/db';
import { Router } from '@angular/router';
import { Select, Store } from '@ngxs/store';
import { UserSelectors } from './states/user-selectors';
import { LoadUserAction, LogOutAction } from './states/user-actions';
import * as moment from 'moment';
import { OauthService } from './services/oauth.service';
import { SuccessOautResponse } from './models/oauth.model';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {
  @Select(UserSelectors.getUser) User$!: Observable<User>;

  public appPages = [
    //   { title: 'Clienti', url: '/clienti', icon: 'people' , params : {clientilist : true}},
    { title: 'Catalogo', url: '/catalogo', icon: 'book' },
    { title: 'Cedole', url: '/cedole', icon: 'documents' },
    //  { title: 'Scansiona codice', url: '/barcode', icon: 'barcode'  },
    //  { title: 'Menu Sincronizzazione', url: '/sync', icon: 'sync'  },
    //<ion-icon name="library-outline"></ion-icon>
  ];
  public userPages = [
    { title: 'Carrelli', url: '/carrelli', icon: 'cart', id: 5 },
    { title: 'Carrello', url: '/carrello', icon: 'cart', id: 0 },
    {
      title: 'Ordini da trasmettere',
      url: '/ordini-da-trasmettere',
      icon: 'file-tray',
      id: 1,
    },
    {
      title: 'Ordini trasmessi',
      url: '/ordini-trasmessi',
      icon: 'file-tray',
      id: 10,
    },
    {
      title: 'Ordini da evadere',
      url: '/ordini',
      icon: 'file-tray-full',
      id: 6,
    },
    {
      title: 'Arrivi / Rimanenze',
      url: '/arrivi-rimanenze',
      icon: 'file-tray-full',
      id: 2,
    },
    {
      title: 'Ultime consegne',
      url: '/ultime-consegne',
      icon: 'file-tray-full',
      id: 3,
    },
    {
      title: 'Prenotazioni',
      url: '/prenotazioni',
      icon: 'file-tray-full',
      id: 4,
    },
    {
      title: 'Autorizzazione resa',
      url: '/autorizzazione-resa',
      icon: 'library',
      id: 9,
    },
    /*  { title: 'Budget', url: '/budget', icon: 'calculator', id: 11},
     */
  ];
  public appButtons = [
    { title: 'Seleziona cliente', url: '/clienti', icon: 'people' },
    { title: 'Menu Sincronizzazione', url: '/sync', icon: 'sync' },
    /*     { title: 'Scansiona un barcode', url: '/barcode', icon: 'barcode' }, */
  ];
  loaders = { prenotazioni: false, ddt: false, ordini: false };
  public appname;
  public user: User;
  public userIsLogged = false;
  public selectedCliente: clienteBE = null;
  public status: Subject<ConnectionStatus>;
  public npezzi = 0;
  public ordersToSend: number;
  public ordersSended: number;
  public ordiniClienti = '';
  public ddtClienti = 0;
  public prenotazioni = '';
  public nrtestate = 0;
  public settingMenu = true;
  public carrelli = 0;
  public carrello: cart;
  public theme = null;
  selectedTheme: string;
  destroy$: Subject<boolean> = new Subject<boolean>();
  private previusValue = null;
  public $sottoscriscrioneCarrello: Observable<cart> = null;
  private $sottoscrizioneOrdiniDaTrasmettere: Observable<number> = null;
  private $eventListener = null;
  public isB2b = false;
  public version;

  constructor(
    private userservice: UserService,
    private network: NetworkService,
    private platformservice: Platform,
    private carrelloservice: CartService,
    private messageservice: MessageService,
    private themeservice: ThemeService,
    private router: Router,
    private store: Store,
    private oauth: OauthService,
  ) {
    this.store.dispatch(new LoadUserAction());
  }

  ngOnInit(): void {
    const t = setInterval(() => {
      const when = moment.unix(Number(localStorage.getItem('when'))).unix();
      const ora = moment().unix();
      if (ora > when && when !== 0) {
        this.oauth.refresh().subscribe((data: SuccessOautResponse) => {
          this.oauth.setToken(data.access_token);
          this.oauth.setRefreshToken(data);
        });
      }
    }, 5000);

    this.User$.subscribe({
      next: (user: User) => {
        this.user = user;
        const info = user?.tabinfo?.tbr_b2c;
        this.isB2b = info === ' ' ? true : false;
      },
    });

    //  this.productsrv.getCache();
    this.selectedCliente = this.userservice.getCliente();
    if (this.selectedCliente) {
      this.carrelloservice
        .loadCart(this.selectedCliente.conto)
        .then((storeCart: cart) => {
          this.npezzi = storeCart
            ? _.sumBy(storeCart.righe, (o) => Number(o.qta))
            : 0;
        });
    }

    this.version = config.version;
    this.platformservice.ready().then(() => {
      // window.screen.orientation.lock('portrait');
      this.themeservice.getActiveTheme().subscribe((th) => {
        this.theme = th;
      });

      this.status = this.network.netStatus;
    });

    /* const $eventListener = this.messageservice.listenEvent();
     */
    this.sottoscrizioneEventMenager();
    this.getCarrelli();
    this.userservice.listenCliente().pipe(takeUntil(this.destroy$)).subscribe((data: clienteBE) => {
      this.selectedCliente = data;
      this.caricaOrdiniDaTrasmettere();
      this.caricaOrdiniPrenotazioneClienti();
      this.caricaDDTClienti();
      this.getCarrelli();
    });
    this.sottoscriviCarrello();
    this.sottoscriviOrdiniDaTrasmettere();
    this.caricaOrdiniDaTrasmettere();
    this.caricaOrdiniTrasmessi();
    this.caricaOrdiniPrenotazioneClienti();
    this.caricaDDTClienti();
  }

  /**
   * caricaOrdiniDaTrasmettere
   */
  public caricaOrdiniDaTrasmettere() {
    this.ordersToSend = 0;
    /*   this.carrelloservice.loadOrdersForCustomer((this.selectedCliente) ? this.selectedCliente.conto : null).then(() => {

    }); */

    this.carrelloservice.loadToSendOrders().then((data) => {
      if (data) {
        this.ordersToSend = data.length;
      }
    });

    /*  this.carrelloservice.loadOrdersForCustomer((this.selectedCliente) ? this.selectedCliente.conto : null).then((data) => {
      this.ordersToSend = data;
    }); */
  }

  public caricaOrdiniTrasmessi() {
    this.carrelloservice
      .loadSendedOrders()
      .then((data: Array<ordineDaTrasmettere>) => {
        const orders = data ? data : [];
        this.ordersSended = orders.length;
      });
  }

  menuToggle() {
    this.settingMenu = !this.settingMenu;
  }

  sottoscrizioneEventMenager() {
    if (!this.$eventListener) {
      this.$eventListener = this.messageservice.listenEvent();
      this.$eventListener.subscribe((data: eventModel) => {
        if (data.type === 'reload') {
          this.sottoscriviOrdiniDaTrasmettere();
          this.caricaOrdiniDaTrasmettere();
          this.caricaOrdiniTrasmessi();
          this.caricaOrdiniPrenotazioneClienti();
          this.caricaDDTClienti();
        }
      });
    }
  }

  sottoscriviCarrello() {
    this.carrelloservice.listenCart().pipe(takeUntil(this.destroy$)).subscribe((storeCart: cart) => {
      this.npezzi = storeCart
        ? _.sumBy(storeCart.righe, (o) => Number(o.qta))
        : 0;
    });
  }
  caricaOrdiniPrenotazioneClienti() {
    if (this.user) {
      if (this.selectedCliente) {
        this.loaders.prenotazioni = true;
        this.loaders.ordini = true;
        db.getOrdini(this.selectedCliente.conto).then((ordini) => {
          this.ordiniClienti = getQuantita(ordini);
          const g = _.groupBy(ordini, 'nr_ordine');
          this.nrtestate = Object.keys(g).length;
          this.loaders.ordini = false;
          db.getPrenotazioni(this.selectedCliente.conto).then(
            (prenotazioni) => {
              this.prenotazioni = getPrenotazioni(prenotazioni);
              this.loaders.prenotazioni = false;
            },
          );
        });
      } else {
        this.ordiniClienti = window.localStorage.getItem('qta_ordini');
        this.prenotazioni = window.localStorage.getItem('qta_prenotazioni');
        this.nrtestate = Number(window.localStorage.getItem('nrtestate'));
      }
    }
  }
  caricaDDTClienti() {
    if (this.user) {
      this.loaders.ddt = true;
      if (this.selectedCliente) {
        db.getDDT(this.selectedCliente.conto).then((ddt) => {
          const ddt_cliente = _.groupBy(ddt, 'ddt_id');
          this.ddtClienti = Object.keys(ddt_cliente).length;
          this.loaders.ddt = false;
        });
      } else {
        this.ddtClienti = Number(window.localStorage.getItem('qta_ddt'));
        this.loaders.ddt = false;
      }
    }
  }
  /**
   * sottoscriviOrdiniDaTrasmettere
   */
  sottoscriviOrdiniDaTrasmettere() {
    if (!this.$sottoscrizioneOrdiniDaTrasmettere) {
      this.$sottoscrizioneOrdiniDaTrasmettere =
        this.carrelloservice.listenOrdersToSend();
      this.$sottoscrizioneOrdiniDaTrasmettere.subscribe((data: number) => {
        this.ordersToSend = data;
      });
    }
  }

  getCarrelli() {
    this.carrelloservice.loadCarts().then((data: Array<cart>) => {
      this.carrelli = _.filter(data, (o: cart) => {
        if (!o.closed && o.cliente && o.righe.length) {
          return true;
        }
        return false;
      }).length;
    });
  }

  mostraCarrello(item: any) {
    if (item.id === 0 && this.selectedCliente) {
      return true;
    }

    if (item.id === 5 && this.selectedCliente) {
      return false;
    }

    if (item.id > 0) {
      return true;
    }

    return false;
  }

  unselectCliente() {
    this.userservice.setCliente(null);
  }

  logout() {
    this.store.dispatch(new LogOutAction());

    this.router.navigateByUrl('login');
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();

  }
}
